const sortAlphaNumeric = (field,order,fieldType) => {
    return function(a,b) {
        let eleA = a[field];
        let eleB = b[field];
        if(!eleA){
            eleA = "";
        }
        if(!eleB){
            eleB = "";
        }
        if(fieldType === 'alpha'){
            if(order === 'asc'){
                return eleA.localeCompare(eleB);
            } else {
                return eleB.localeCompare(eleA);
            }
        } else if (fieldType === 'date') {
            if(order === 'asc'){
                return new Date(eleA) - new Date(eleB);
            } else {
                return new Date(eleB) - new Date(eleA);
            }
        } else {
            if(order === 'asc'){
                return a[field] - b[field];
            } else {
                return b[field] - a[field];
            }
        }
    }
};

export { sortAlphaNumeric };